/**
 * 악덕알리미 공지사항 BS (BottomSheet) — evil-alert-merged 퍼블리싱 디자인.
 *
 * 사용: $j.F.Devil.Notice.open()
 *
 * 리스트는 BS 안에 카드형으로 렌더(전체/분류 탭 + 핀 + NEW).
 * 글을 누르면 인라인 펼침이 아니라 **상세 모달**이 뜬다. (BS 는 유지)
 * 데이터: /b/ajax/notices (목록), /b/ajax/notice/{id} (본문). 본문은 HTML(<br>).
 * 메모리 "악덕알리미는 JS 클라 렌더링 우선" — Blade 셸 없이 인라인 스타일(테마변수)로 렌더.
 */
function buildTarget(){
    let ALL = [];
    let CATS = [];
    let curCat = '';

    return {
        init() {
            const self = this;
            const $cont = $('#' + this.id);
            $cont.html(loadingHtml('불러오는 중…'));
            self.parent.setTitle('공지사항');

            fetch('/b/ajax/notices')
                .then(r => r.json())
                .then(res => {
                    if (!res || !res.result) {
                        $cont.html(loadingHtml(esc(res && res.message || '불러오기 실패')));
                        return;
                    }
                    ALL  = res.list || [];
                    CATS = res.categories || [];
                    $cont.html(shellHtml());
                    bind($cont);
                    renderList($cont);
                })
                .catch(() => $cont.html(loadingHtml('네트워크 오류')));
        },
        destroy() {}
    };

    function shellHtml(){
        const tabs = [{k:'', l:'전체'}].concat(CATS.map(c => ({k:c, l:c})));
        const tabBtn = (t) => {
            const on = t.k === curCat;
            return `<button class="nt-tab" data-cat="${esc(t.k)}" style="`
                + `padding:5px 14px;border-radius:999px;cursor:pointer;font-size:${fs(13)}px;font-weight:500;`
                + (on ? 'border:none;background:var(--R);color:var(--on-brand);' : 'border:1px solid var(--bdr);background:var(--sf);color:var(--t2);')
                + `">${esc(t.l)}</button>`;
        };
        // (2026-09) 위/좌/우 패딩 제거 — BS content-area(_bs-devil.scss)가 이미 그 여백을
        // 담당하는데 여기서 또 줘서 이중으로 넓어 보이던 문제(상필 님 QA, .b-cfg BS와 동일
        // 원인). 하단 여유 공간만 남긴다.
        return `<div style="padding:0 0 20px">
            <div class="nt-tabs" style="display:flex;gap:8px;flex-wrap:wrap;margin-bottom:12px">${tabs.map(tabBtn).join('')}</div>
            <div class="nt-list"></div>
        </div>`;
    }

    function bind($cont){
        $cont.off('click.ntTab').on('click.ntTab', '.nt-tab', function(){
            curCat = $(this).attr('data-cat') || '';
            $cont.html(shellHtml()); bind($cont); renderList($cont);
        });
        $cont.off('click.ntItem').on('click.ntItem', '.nt-item', function(){
            openNoticeModal($(this).attr('data-num'));
        });
    }

    function renderList($cont){
        const fi = curCat ? ALL.filter(n => n.category === curCat) : ALL;
        const sorted = [...fi.filter(n => n.pinned), ...fi.filter(n => !n.pinned)];
        const $list = $cont.find('.nt-list');
        if (!sorted.length) { $list.html(loadingHtml('등록된 공지가 없습니다.')); return; }
        $list.html(sorted.map(itemHtml).join(''));
    }

    function itemHtml(n){
        return `<div class="nt-item" data-num="${n.num}" style="`
            + `background:var(--sf);border:1px solid var(--bdr);border-radius:12px;padding:11px 14px;margin-bottom:8px;cursor:pointer">`
            + `<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:4px">`
            +   `<span style="font-size:${fs(13)}px;color:var(--t3)">${n.category ? '[' + esc(n.category) + ']' : ''}</span>`
            +   `<span style="font-size:${fs(13)}px;color:var(--t3)">${formatDate(n.created_at)}</span>`
            + `</div>`
            + `<div style="display:flex;align-items:center;gap:8px">`
            +   (n.pinned ? pinSvg() : '')
            +   `<span style="font-size:${fs(15)}px;font-weight:500;color:var(--t1);flex:1;word-break:break-word">${esc(n.title)}</span>`
            +   (n.is_new ? `<span style="font-size:${fs(11)}px;font-weight:700;color:var(--R);flex-shrink:0">NEW</span>` : '')
            + `</div>`
            + `</div>`;
    }

    function loadingHtml(msg){
        return `<div style="padding:24px;text-align:center"><span style="color:var(--t3);font-size:${fs(13)}px">${msg}</span></div>`;
    }
    function pinSvg(){
        return '<svg width="14" height="14" viewBox="0 0 18 18" fill="none" style="flex-shrink:0">'
            + '<path d="M9 2v7M6 9h6l-1 5H7l-1-5z" stroke="var(--R)" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    }
}

/** 공지 상세 모달 — BS 위에 뜨는 중앙 모달 (퍼블리싱 디자인). */
function openNoticeModal(num){
    if (!num) return;
    fetch(`/b/ajax/notice/${num}`)
        .then(r => r.json())
        .then(res => {
            if (!res || !res.result) {
                showModal('공지', `<p style="color:var(--t3);font-size:${fs(14)}px">${esc(res && res.message || '본문 불러오기 실패')}</p>`);
                return;
            }
            const r = res.row;
            const cover = r.cover_url ? `<div style="margin-bottom:12px"><img src="${esc(r.cover_url)}" alt="" style="max-width:100%;border-radius:8px"></div>` : '';
            const head = `<p style="font-size:${fs(18)}px;font-weight:700;color:var(--t1);line-height:1.4;margin-bottom:4px;padding-right:8px">${esc(r.title)}</p>`
                + `<p style="font-size:${fs(13)}px;color:var(--t3)">${(r.category ? '[' + esc(r.category) + ']  ' : '')}${formatDate(r.created_at)}</p>`;
            const body = `<div style="border-top:1px solid var(--sf2);margin-top:12px;padding-top:16px">`
                + cover
                + `<div style="font-size:${fs(14)}px;color:var(--t2);line-height:1.8;word-break:break-word">${r.body || ''}</div>`
                + `</div>`;
            showModal(head, body);
        })
        .catch(() => showModal('공지', `<p style="color:var(--t3);font-size:${fs(14)}px">네트워크 오류</p>`));
}

function showModal(headHtml, bodyHtml){
    $('.nt-modal').remove();
    const $ov = $(`
        <div class="nt-modal" style="position:fixed;inset:0;z-index:var(--z-index-modal,1056);
             background:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center;padding:14px">
            <div class="nt-modal__panel" style="background:var(--sf);border:1px solid var(--bdr2);width:100%;max-width:560px;max-height:94vh;
                 border-radius:16px;overflow:hidden;display:flex;flex-direction:column;box-shadow:0 12px 44px rgba(0,0,0,.5)">
                <div style="position:relative;padding:18px 44px 12px 18px">
                    ${headHtml}
                    <button class="nt-modal__x" aria-label="닫기" style="position:absolute;top:12px;right:12px;width:30px;height:30px;
                        border:none;background:none;cursor:pointer;color:var(--t3);font-size:24px;line-height:1">&times;</button>
                </div>
                <div style="overflow-y:auto;padding:0 18px 22px">${bodyHtml}</div>
            </div>
        </div>`);
    $ov.on('click', (e) => { if (e.target === $ov[0]) $ov.remove(); });
    $ov.find('.nt-modal__x').on('click', () => $ov.remove());
    $('body').append($ov);
}

// 설정 글자크기(<html data-fs>) 는 이제 BS 콘텐츠(.content-area)에 CSS zoom 으로 일괄 반영된다
// (_helpers.scss). 따라서 인라인 px 에 수동 배율을 곱하지 않는다 — 곱하면 이중 배율이 됨.
// fs(px) 는 호환을 위해 raw px 를 그대로 반환(아래 인라인 스타일들이 fs() 를 호출하므로 유지).
function fs(px){ return px; }

function formatDate(s){ return s ? String(s).slice(2,10) : ''; } // 26-03-10
function esc(s){ return String(s==null?'':s).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c])); }

export default class Notice {
    open = () => {
        $j.Ui.BS.open({ target: buildTarget(), fixedHeight: true, backClose: true });
    }
}
